import { React, useEffect, useState, useRef } from 'react';
import { useHistory } from 'react-router-dom';
import styled, { keyframes } from 'styled-components';
import lodash from 'lodash';
import moment from 'moment';

import FetchModule from '../../Share/Network/FetchModule';
import OnSitePaymentMemberShipInfoView from './OnSitePaymentMemberShipInfoView';
import RegistrationLoading from './RegistrationLoading.js';
import WaitingPagePaymentModal from './WaitingPagePaymentModal.js';
import LinkPayMemberShipInfoView from './LinkPayMemberShipInfoView.js';
import OptionSelectBox from '../../../MemberRegistration/Model/OptionSelectBox.js';
import CustomInput from '../../../MemberRegistration/Component/CustomInput.js';
import PaymentOptionSettingSelectBox from '../../../MemberRegistration/Model/PaymentOptionSettingSelectBox.js';
import CalenderInput from '../../../MemberRegistration/Component/CalendarInput.js';
import PaymentOptionCustomInput from '../../../MemberRegistration/Component/PaymentOptionCustomInput.js';
import ColorCustomInput from '../../../MemberRegistration/Component/ColorCustomInput.js';


import WhiteTrashIcon from '../../../image/WhiteTrashIcon.png';
import AddPaymentOptionModal from '../../../MemberRegistration/Model/AddPaymentOptionModal.js';
import LinkoPayPaymentModal from '../../../MemberRegistration/Model/LinkoPayPaymentModal.js';

// 하하 //
const OnSitePaymentModal = (props) => {
  const {
    isUsePaymentSystem,
    userData,
    merchantUid,
    rerendering,
    setRerendering,
    cancel,
    closeFn
  } = props;

  const history = useHistory();

  const [data, setData] = useState(undefined);
  const [isClicked, setIsClicked] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  // const [startDate, setStartDate] = useState('');
  // const [endDate, setEndDate] = useState('');
  const [productName, setProductName] = useState('');
  const [productCoach, setProductCoach] = useState('');
  const [productValidity, setProductValidity] = useState(0);
  const [card, setCard] = useState(0);
  const [cash, setCash] = useState(0);
  // const [discount, setDiscount] = useState(0);
  // const [notReceived, setNotReceived] = useState(0);
  const [point, setPoint] = useState(0);
  const [isLinkPay, setIsLinkPay] = useState(false);
  const [totalPoint, setTotalPoint] = useState(0);

  const [totalRegistData, setTotalRegistData] = useState(undefined);

  const DefaultPaymentOption = [{ id: 0, name: '현금' }, { id: 0, name: '카드' }, { id: 0, name: '포인트' }];

  // status //
  const [isEdit, setIsEdit] = useState(false);
  const [isClickedAddPaymentOption, setIsClickedAddPaymentOption] = useState(false);
  const [isUseLinkoPay, setIsUseLinkoPay] = useState(false);
  const [isViewPaymentModal, setIsViewPaymentModal] = useState(false);

  const [isInProgress, setIsInProgress] = useState(false);
  // status //

  // value //
  const [prevSalesColor, setPrevSalesColor] = useState('#000000');

  const [memberships, setMemberships] = useState([]);
  const [categories, setCategories] = useState([]);
  const [categorizedMemberships, setCategorizedMemberships] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState({ id: 0, name: '선택' });
  const [selectedMembership, setSelectedMembership] = useState({ id: 0, name: '선택' });
  const [paymentOptions, setPaymentOptions] = useState([{ id: 0, name: '현금' }, { id: 0, name: '카드' }, { id: 0, name: '포인트' }]);
  const [selectedPaymentOptions, setSelectedPaymentOptions] = useState([{ id: 0, name: '현금', price: 0 }]);

  const [startDate, setStartDate] = useState(moment().format('YYYY.MM.DD'));
  const [endDate, setEndDate] = useState(moment().format('YYYY.MM.DD'));
  const [approvalDate, setApprovalDate] = useState(moment().format('YYYY.MM.DD'));
  const [totalMax, setTotalMax] = useState(-1);
  const [discount, setDiscount] = useState('0');
  const [notReceived, setNotReceived] = useState('0');

  const [originalApprovalDate, setOriginalApprovalDate] = useState('');
  const [originalCardPrice, setOriginalCardPrice] = useState('');
  const [originalSelectedPaymentOptions, setOriginalSelectedPaymentOptions] = useState([{ id: 0, name: '현금', price: 0 }]);
  // value //

  const InfoViewRef = useRef();

  // 스크롤 제어 //
  useEffect(() => {
    document.body.style = `overflow: hidden`;
    return () => document.body.style = `overflow: auto`;
  }, [])

  useEffect(() => {
    if (merchantUid === undefined) return;

    setIsLinkPay(merchantUid.split('-')[2] === '1');

    if (merchantUid.split('-')[2] === '0') {
      let requestData = {
        merchantUid: merchantUid
      }

      const fetchModule = new FetchModule();
      (
        async () => {
          const responseData = await fetchModule.postData('sales/merchant_auto_data/', 'POST', requestData);

          if (responseData.status === 200) {
            setData(responseData.data[0])
          }
          else if (responseData.status === 401) {
            alert('로그인 후 다시시도하세요');
            history.push('/');
          }
        }
      )();
    }
    else {
      const fetchModule = new FetchModule();
      (
        async () => {
          const responseData = await fetchModule.postData('sales/merchant_data/' + merchantUid, 'POST');
          //  console.log(responseData);
          if (responseData.status === 200) {
            setData(responseData.data[0])
          }
          else if (responseData.status === 401) {
            alert('로그인 후 다시시도하세요');
            history.push('/');
          }
        }
      )();
    }
  }, [merchantUid])

  // Point 현황 불러오기 //
  useEffect(() => {
    let requestData = {
      storeId: userData.storeId,
      userId: userData.userId
    }

    const fetchModule = new FetchModule();
    (
      async () => {
        const responseData = await fetchModule.postDataVersion2('point/available/find_member', 'POST', requestData);
        // console.log(responseData);
        if (responseData.status === 200) {
          setTotalPoint(responseData.data.totalPoint);
        }
      }
    )();
  }, [userData])

   // 링크페이 사용여부 확인하기 //
  useEffect(() => {
    const fetchModule = new FetchModule();
    (
      async () => {
        const responseData = await fetchModule.getIndividualData('store/check/linkpay', 'GET');
        // console.log(responseData);
        if (responseData.status === 200) setIsUseLinkoPay(responseData.data[0]);
      }
    )();
  }, [])

  // 카테고리 및 회원권 데이터 불러오기 //
  useEffect(() => {
    const fetchModule = new FetchModule();
    (
      async () => {
        const responseData = await fetchModule.getDataVersion2('membership/', 'GET');

        if (responseData.status === 200) {
          setMemberships(responseData.data.memberShips);
          setCategories(responseData.data.categories);
        }
        else if (responseData.status === 401) history.push('/');
      }
    )();
  }, [history])

  // 결제수단 데이터 불러오기 //
  useEffect(() => {
    const fetchModule = new FetchModule();
    (
      async () => {
        const responseData = await fetchModule.getDataVersion2('payment_option/', 'GET');

        if (responseData.status === 200) {
          let newPaymentOptions = DefaultPaymentOption.concat(responseData.data.paymentOptions);

          setPaymentOptions(newPaymentOptions);
        }
        else if (responseData.status === 401) history.push('/');
      }
    )();
  }, [])

  // 회원권 생성 또는 수정여부 결정 //
  useEffect(() => {
    if (data === undefined) return;

    const willSelectCategory = categories.find(c => c.id === data.categoryId) || { id: 0, name: '선택' };
    const willSelectMembership = memberships.find(m => m.id === data.membershipId) || { id: 0, name: '선택' };

    setSelectedCategory(willSelectCategory);

    setTimeout(() => {
      setSelectedMembership(willSelectMembership)
      setStartDate(moment().format('YYYY.MM.DD'));

      let division = 'days';

      if (data.validityUnit === 'year') division = 'year';
      else if (data.validityUnit === 'month') division = 'month';

      setEndDate(moment().add(data.validity, division).subtract(1, 'days').format('YYYY.MM.DD'));
      setApprovalDate(moment().format('YYYY.MM.DD'));
    }, 150);

    setTotalMax(data.totalMax);
  }, [categories, memberships, data])

  // 카테고리에 따라 회원권 정렬하기 //
  useEffect(() => {
    if (selectedCategory === undefined || selectedCategory.id === 0) {
      setCategorizedMemberships([]);
      setSelectedMembership({ id: 0, name: '선택' });
      return;
    }

    let newCategorizedMemberships = [];

    for (let i = 0; i < memberships.length; i++) {
      if (selectedCategory.id === memberships[i].categoryId) {
        newCategorizedMemberships.push(memberships[i]);
      }
    }

    setSelectedMembership({ id: 0, name: '선택' });
    setCategorizedMemberships(newCategorizedMemberships);
  }, [selectedCategory, memberships])

  // 회원권 종료일 자동 세팅 //
  useEffect(() => {
    if (startDate === '' || selectedMembership.id === 0) return;

    let validity = selectedMembership.validity;
    let division = selectedMembership.validityUnit;

    setEndDate(moment(startDate, 'YYYY.MM.DD').add(validity, division).subtract(1, 'days').format('YYYY.MM.DD'));
  }, [startDate, selectedMembership]);

  // 미수금 산정하기 //
  useEffect(() => {
    if (selectedMembership.id === 0) {
      setNotReceived(0);
      return;
    }

    let totalPrice = 0;

    for (let i = 0; i < selectedPaymentOptions.length; i++) {
      if (selectedPaymentOptions[i].price !== '') totalPrice += parseInt(selectedPaymentOptions[i].price.toString().replaceAll(',', '') ?? 0);
    }

    if (discount !== '') totalPrice += parseInt(discount.toString().replaceAll(',', ''));

    setNotReceived(Math.max(selectedMembership.price - totalPrice, 0));
  }, [selectedMembership, selectedPaymentOptions, discount]);

  // 회원권 총 횟수 세팅 //
  useEffect(() => {
    if (selectedMembership.id === 0) setTotalMax(-1);
    else setTotalMax(selectedMembership.totalMax);
  }, [selectedMembership])

  // 최대 수강 횟수 변경시 //
  function onChangeTotalMax(value) {
    const onlyNumber = value.replace(/[^0-9]/g, ''); // 숫자 이외 제거
    setTotalMax(Number(onlyNumber));
  }

  // 결제 옵션 추가 버튼 클릭시 //
  function onClickAdditionOption() {
    setIsClickedAddPaymentOption(true);
  }

  // 이전 등록 회원권 정보 뷰 정리 //
  function onCalcPrevSalesInfo(className) {
    if (userData === undefined || userData.prevSales === undefined || userData.prevMemberShip === undefined) return '';

    if (className === 'MemberShipName') return userData.prevSales.itemName;
    else if (className === 'Date') return moment(userData.prevUsage.startDate).format('YY.MM.DD') + ' - ' + moment(userData.prevUsage.endDate).format('YY.MM.DD');
    else if (className === 'TotalPrice') {
      if (userData.prevUsage.selectedPaymentOptions === undefined || userData.prevUsage.selectedPaymentOptions.length === 0) {
        if (userData.prevUsage.cardPrice === 0 && userData.prevUsage.cashPrice === 0) return '무료';
        else if (userData.prevUsage.cardPrice === 0) return userData.prevUsage.cashPrice.toLocaleString('ko-KR') + ' - 현금';
        else if (userData.prevUsage.cashPrice === 0) return userData.prevUsage.cardPrice.toLocaleString('ko-KR') + ' - 카드';
        else return (parseInt(userData.prevUsage.cashPrice) + parseInt(userData.prevUsage.cardPrice)).toLocaleString('ko-KR') + ' - 복합결제';
      }
      else {
        const allSame = userData.prevUsage.selectedPaymentOptions.every(item => item.paymentOptionName === userData.prevUsage.selectedPaymentOptions[0].name);
        const totalPrice = userData.prevUsage.selectedPaymentOptions.reduce((sum, item) => sum + item.price, 0);

        if (allSame) return totalPrice.toLocaleString('ko-KR') + ' - ' + userData.prevUsage.selectedPaymentOptions[0].paymentOptionName;
        else return totalPrice.toLocaleString('ko-KR') + ' - 복합결제';
      }
    }
    else if (className === 'NotReceivedPrice') return userData.prevUsage.notReceivedPrice.toLocaleString('ko-KR');
    else if (className === 'Validity') {
      if (moment(userData.prevUsage.endDate).diff(moment(), 'day') >= 0) return moment(userData.prevUsage.endDate).diff(moment(), 'day') + '일';
      else return '만료';
    }
    else if (className === 'TotalMax') {
      if (userData.prevUsage.totalMax === -1) return userData.prevUsage.courseTakeCount + '/∞';
      else return userData.prevUsage.courseTakeCount + '/' + userData.prevUsage.totalMax;
    }
  }

  // 이전 등록 회원권 정보 호버링 //
  function onMouseOverPrevSales() {
    setPrevSalesColor('#FF8B48');
  }

  // 이전 등록 회원권 정보 호버링 //
  function onMouseLeavePrevSales() {
    setPrevSalesColor('#000000');
  }

  // 이전 기록 클릭시 회원권 세팅
  function onClickPrevSales() {
    if (userData === undefined) return;

    const willSelectCategory = categories.find(c => c.id === userData.prevMemberShip.categoryId) || { id: 0, name: '선택' };
    const willSelectMembership = memberships.find(m => m.id === userData.prevMemberShip.id) || { id: 0, name: '선택' };

    setSelectedCategory(willSelectCategory);

    setTimeout(() => (
      setSelectedMembership(willSelectMembership)
    ), 150);

    if (userData.prevUsage.selectedPaymentOptions !== undefined
      && userData.prevUsage.selectedPaymentOptions.length > 0) {
      let newSelectedPaymentOptions = lodash.cloneDeep(userData.prevUsage.selectedPaymentOptions);

      for (let i = 0; i < newSelectedPaymentOptions.length; i++) {
        newSelectedPaymentOptions[i].id = newSelectedPaymentOptions[i].paymentOptionId;
      }

      setSelectedPaymentOptions(newSelectedPaymentOptions);
    }
    else {
      let newSelectedPaymentOptions = [];

      if (userData.prevUsage.cashPrice !== 0) newSelectedPaymentOptions.push({ id: 0, name: '현금', price: userData.prevUsage.cashPrice });
      if (userData.prevUsage.cardPrice !== 0) newSelectedPaymentOptions.push({ id: 0, name: '카드', price: userData.prevUsage.cardPrice });
      if (userData.prevUsage.point !== 0) newSelectedPaymentOptions.push({ id: 0, name: '포인트', price: userData.prevUsage.point });

      setSelectedPaymentOptions(newSelectedPaymentOptions);
    }

    setTotalMax(userData.prevUsage.totalMax);
    setDiscount(userData.prevUsage.discountPrice.toString());
    setNotReceived(userData.prevUsage.notReceivedPrice.toString());
  }

  // 결제수단 모달 내에서 결제수단 저장하기 클릭시 //
  function onClickSavePaymentOption(optionName) {
    if (optionName === '') {
      alert('결제수단의 이름을 입력해주세요');
      return;
    }

    if (isLoading) {
      alert('저장을 진행중입니다');
      return;
    }

    setIsLoading(true);

    let requestData = {
      optionName: optionName
    }

    const fetchModule = new FetchModule();
    (
      async () => {
        const responseData = await fetchModule.postDataVersion2('payment_option/save', 'POST', requestData);

        if (responseData.status === 200) {
          let newPaymentOptions = DefaultPaymentOption.concat(responseData.data.paymentOptions);

          setPaymentOptions(newPaymentOptions);
          setIsLoading(false);
          setIsClickedAddPaymentOption(false);
        }
        else if (responseData.status === 401) history.push('/');
        else {
          alert(responseData.error);
          setIsLoading(false);
        }
      }
    )();
  }

  // 결제 수단 삭제버튼 클릭시 //
  function onClickDeleteOption(paymentOptionId) {
    if (isLoading) {
      alert('삭제를 진행중입니다');
      return;
    }

    setIsLoading(true);

    let requestData = {
      paymentOptionId: paymentOptionId
    }

    const fetchModule = new FetchModule();
    (
      async () => {
        const responseData = await fetchModule.postDataVersion2('payment_option/delete', 'POST', requestData);

        if (responseData.status === 200) {
          let newPaymentOptions = DefaultPaymentOption.concat(responseData.data.paymentOptions);

          setPaymentOptions(newPaymentOptions);
          setIsLoading(false);
          setIsClickedAddPaymentOption(false);
        }
        else if (responseData.status === 401) history.push('/');
        else {
          alert(responseData.error);
          setIsLoading(false);
        }
      }
    )();
  }


  // 회원권 결제 수단 변경시 //
  function onChangeSelectedPaymentOptions(data, index) {
    let newSelectedPaymentOptions = selectedPaymentOptions.slice();

    newSelectedPaymentOptions[index].id = data.id;
    newSelectedPaymentOptions[index].name = data.name;

    setSelectedPaymentOptions(newSelectedPaymentOptions);
  }

  // 회원권 결제 금액 변경시 //
  function onChangePaymentOptionPrice(value, index) {
    let newSelectedPaymentOptions = selectedPaymentOptions.slice();
    let finalValue = value.replaceAll(',', '');

    if (finalValue !== '') newSelectedPaymentOptions[index].price = parseInt(finalValue).toLocaleString('ko-KR');
    else newSelectedPaymentOptions[index].price = finalValue;

    setSelectedPaymentOptions(newSelectedPaymentOptions);
  }

  // 할인 금액 변경시 //
  function onChangeDiscount(value) {
    let finalValue = value.replaceAll(',', '');

    if (finalValue !== '') setDiscount(parseInt(finalValue).toLocaleString('ko-KR'));
    else setDiscount(finalValue);
  }

  // 회원권 결제 수단 추가 버튼 클릭시 //
  function onClickAddPaymentOptions() {
    let newSelectedPaymentOptions = selectedPaymentOptions.slice();

    newSelectedPaymentOptions.push({ id: 0, name: '현금', price: 0 });

    setSelectedPaymentOptions(newSelectedPaymentOptions);
  }

  // 회원권 결제 수단 제거 버튼 클릭시 //
  function onClickDeletePaymentOptions(index) {
    let newSelectedPaymentOptions = selectedPaymentOptions.slice();

    newSelectedPaymentOptions.splice(index, 1);

    setSelectedPaymentOptions(newSelectedPaymentOptions);
  }

  // 등록을 위해 모든 데이터가 채워졌는지 여부 확인 //
  function checkAvailableRegistration() {
    if (startDate === '') {
      alert('회원권 시작날짜를 설정해주세요');
      return false;
    }

    if (endDate === '') {
      alert('회원권 종료날짜를 설정해주세요');
      return false;
    }

    if (approvalDate === '') {
      alert('회원권 결제 날짜를 설정해주세요');
      return false;
    }

    if (selectedMembership.id === 0) {
      alert('회원권을 선택해주세요');
      return false;
    }

    let checkStartDate = moment(startDate.replaceAll('.', '-') + 'T' + moment().format('HH:mm:ss'));
    let checkEndDate = moment(endDate.replaceAll('.', '-') + 'T23:59:59');

    if (checkEndDate.isBefore(checkStartDate)) {
      alert('회원권 종료일자를 올바르게 입력해주세요');
      return false;
    }

    return true;
  }

    // 등록하기 버튼 클릭시 //
  function onClickRegistrationButton() {
    if (selectedMembership.id === 0) {
      alert('회원권을 선택해주세요!');
      return;
    }

    let checkStartDate = moment(startDate.replaceAll('.', '-') + 'T00:00:00');
    let checkEndDate = moment(endDate.replaceAll('.', '-') + 'T23:59:59');

    if (checkEndDate.isBefore(checkStartDate)) {
      alert('종료일자를 올바르게 입력해주세요');
      return;
    }

    let finalCashPrice = 0;
    let finalCardPrice = 0;
    let finalPoint = 0;

    let finalSelectedPaymentOptions = [];

    for (let i = 0; i < selectedPaymentOptions.length; i++) {
      if (selectedPaymentOptions[i].price !== ''
        && selectedPaymentOptions[i].price !== 0) finalSelectedPaymentOptions.push(selectedPaymentOptions[i]);
    }


    for (let i = 0; i < finalSelectedPaymentOptions.length; i++) {
      if (finalSelectedPaymentOptions[i].id === 0) {
        if (finalSelectedPaymentOptions[i].name === '현금') finalCashPrice += parseInt(finalSelectedPaymentOptions[i].price.toString().replaceAll(',', ''));
        else if (finalSelectedPaymentOptions[i].name === '카드') finalCardPrice += parseInt(finalSelectedPaymentOptions[i].price.toString().replaceAll(',', ''));
        else if (finalSelectedPaymentOptions[i].name === '포인트') finalPoint += parseInt(finalSelectedPaymentOptions[i].price.toString().replaceAll(',', ''));
      }

      finalSelectedPaymentOptions[i].price = parseInt(finalSelectedPaymentOptions[i].price.toString().replaceAll(',', ''));
    }

    if (parseInt(finalPoint) > 0 && parseInt((finalPoint).toString().replaceAll(',', '')) > parseInt(totalPoint.toString().replaceAll(',', ''))) {
      alert('사용가능한 포인트를 초과하였습니다');
      return;
    }
    
    setProductName(selectedMembership.name);
    setProductCoach('');
    setProductValidity(selectedMembership.validity);
    setCard(finalCardPrice);
    setCash(finalCashPrice);
    // setDiscount(discountPrice);
    // setNotReceived(notReceivedPrice);
    setPoint(finalPoint);


    let name = userData.userName;
    let birthDay = (userData.birthDay.slice(7, 8) === '1' || userData.birthDay.slice(7, 8) === '2') ? '19' + userData.birthDay.slice(0, 6) : '20' + userData.birthDay.slice(0, 6);
    let gender = (userData.birthDay.slice(7, 8) === '1' || userData.birthDay.slice(7, 8) === '3') ? 'male' : 'female';
    let phone = userData.phone;
    let id = userData.userId;
    let profile = userData.profile;

    let registData = {
      name: name,
      birthDay: birthDay,
      gender: gender,
      phone: phone,
      linkCoachId: id,
      storeId: parseInt(window.localStorage.getItem('StoreId')),
      memberShipName: selectedMembership.name,
      profile: profile,
      memberDetail: '',
      approval: moment().format('YYYY-MM-DDTHH:mm:ss'),
      totalMax: totalMax,
      startDate: moment(startDate).format('YYYY-MM-DDTHH:mm:ss'),
      endDate: moment(endDate).format('YYYY-MM-DDTHH:mm:ss'),
      memberShipId: selectedMembership.id,
      cardPrice: finalCardPrice,
      cashPrice: finalCashPrice,
      discount: parseInt(discount.toString().replaceAll(',', '')),
      notReceived: parseInt(notReceived.toString().replaceAll(',', '')),
      point: finalPoint,
      membershipPaymentOptions: finalSelectedPaymentOptions
      // merchantUid: merchant_uid
    }

    // 링크 페이 결제의 경우 //
    if (isUsePaymentSystem && userData.isUseLinkPay && isLinkPay) {
      setTotalRegistData(registData);
      onClickPaymentOnPayple(registData);
    }
    // 일반 결제의 경우 //
    else {
      setTotalRegistData(registData);
      setIsClicked(true);
    }
  }

  // 현장 결제 버튼 클릭시 //
  function onClickOnSitePayment() {
    if (isLoading) {
      alert('결제를 진행중입니다!');
      return;
    }

    setIsLoading(true);

    let requestData = {
      merchantUid: merchantUid,
      cardPrice: totalRegistData.cardPrice,
      cashPrice: totalRegistData.cashPrice,
      discount: totalRegistData.discount,
      notReceived: totalRegistData.notReceived,
      point: totalRegistData.point,
      approvalDate: moment(approvalDate).format('YYYY-MM-DDTHH:mm:ss'),
      membershipPaymentOptions: totalRegistData.membershipPaymentOptions
    }
    
    const fetchModule = new FetchModule();
    (
      async () => {
        const responseData = await fetchModule.postDataVersion2('sales/onSite/effectiveness', 'POST', requestData);

        if (responseData.status === 200) {
          cancelFunction(responseData.data);
          setIsLoading(false);
        }
        else if (responseData.status === 201) {
          alert('올바르지 않은 요청입니다');
          setIsLoading(false);
          return;
        }
        else if (responseData.status === 202) {
          alert('이미 결제가 진행된 건 입니다.');
          setIsLoading(false);
          return;
        }
        else if (responseData.status === 204) {
          alert('결제 내역이 존재하지 않습니다.');
          setIsLoading(false);
          return;
        }
        // cancel();
      }
    )();
  }

  // 링크페이 결제자의 신청을 승인시 //
  function onClickPaymentOnPayple(totalRegistData) {
    if (isLoading) {
      alert('결제를 진행중입니다!');
      return;
    }

    setIsLoading(true);

    // setTimeout(() => {
    //   setIsLoading(false);
    // }, 3000);

    totalRegistData.merchantUid = merchantUid;

    const fetchModule = new FetchModule();
    (
      async () => {
        const responseData = await fetchModule.postDataVersion2('member/registration/waiting/linkpay', 'POST', totalRegistData);

        // console.log(responseData);
        if (responseData.status === 200) {
          // onRegist(merchant_uid);
          cancel(responseData.data);
          setIsLoading(false);
        }
        else if (responseData.status === 201) {
          alert('링크코치 가입자가 아닙니다.');
          setIsLoading(false);
          return;
        }
        else if (responseData.status === 202) {
          alert('데이터가 존재하지 않습니다');
          setIsLoading(false);
          return;
        }
        else if (responseData.status === 203) {
          alert('데이터가 존재하지 않습니다');
          setIsLoading(false);
          return;
        }
        else if (responseData.status === 204) {
          alert('회원님의 카드가 등록되어있지 않습니다.\n등록 후 사용해주세요');
          setIsLoading(false);
          return;
        }
        else if (responseData.status === 205) {
          alert('결제중 에러가 발생하였습니다.\n잠시 후 다시시도해 주세요');
          setIsLoading(false);
          return;
        }
        else if (responseData.status === 206) {
          alert('구독형 회원권은 결제 금액을 변경할 수 없습니다');
          setIsLoading(false);
          return;
        }
        else {
          alert(responseData.error);
          setIsLoading(false);
          return;
        }
      }
    )();
  }

  function cancelFunction(merchant_uid) {
    let name = userData.userName;
    let birthDay = (userData.birthDay.slice(7, 8) === '1' || userData.birthDay.slice(7, 8) === '2') ? '19' + userData.birthDay.slice(0, 6) : '20' + userData.birthDay.slice(0, 6);
    let gender = (userData.birthDay.slice(7, 8) === '1' || userData.birthDay.slice(7, 8) === '3') ? 'male' : 'female';
    let phone = userData.phone;
    let id = userData.userId;
    let memberShipName = productName;
    let profile = userData.profile;
    // let totalMax = totalMax;
    // let notReceivedPrice = InfoViewRef.current.getNotReceivedPrice();
    let memberShipId = selectedMembership.id;

    let requestData = {
      name: name,
      birthDay: birthDay,
      gender: gender,
      phone: phone,
      linkCoachId: id,
      storeId: window.localStorage.getItem('StoreId'),
      memberShipName: memberShipName,
      profile: profile,
      memberDetail: '',
      approval: moment().format('YYYY-MM-DDTHH:mm:ss'),
      totalMax: totalMax,
      startDate: moment(startDate).format('YYYY-MM-DDTHH:mm:ss'),
      endDate: moment(endDate).format('YYYY-MM-DDTHH:mm:ss'),
      memberShipId: memberShipId,
      merchantUid: merchant_uid
    }
    // console.log(startDate);
    // console.log(endDate);
    // console.log(moment(startDate).format('YYYY.MM.DD HH:mm:ss'));
    // console.log(moment(endDate).format('YYYY.MM.DD HH:mm:ss'));
    // console.log(moment().format('YYYY.MM.DD HH:mm:ss'));
    // console.log(requestData);
    const fetchModule = new FetchModule();
    (
      async () => {
        const responseData = await fetchModule.postDataVersion2('member/registration', 'POST', requestData);

        if (responseData.status === 200) {
          setIsLoading(false);
          cancel(responseData.data);
          setRerendering(!rerendering);
        }
        else if (responseData.status === 201) {
          alert('구매 내역이 존재하지 않습니다');
          return;
        }
        else if (responseData.status === 202) {
          alert('아직 결제가 진행되지 않은 건 입니다');
          return;
        }
        else if (responseData.status === 401) {
          setIsLoading(false);
          alert('로그인 후 사용해주세요');
          history.push('/');
        }
        else {
          setIsLoading(false);
          alert("회원등록에 실패하였습니다. 잠시후 다시시도해 주세요.");
          return;
        }
      }
    )();

    setIsClicked(false);
    closeFn();
  }

  function getApprovalDate() {
    return moment(InfoViewRef.current.getApprovalDate()).format('YYYY-MM-DDTHH:mm:ss');
  }

  // 결제 종료 후 모달창 끄기 //
  function onCompletePaymentForLinkpay(memberData) {
    setIsLoading(false);
    cancel(memberData);
    setRerendering(!rerendering);
    setIsClicked(false);
    closeFn();
  }

  return (
    <TopLevelWrapper>
      {isLoading && <RegistrationLoading />}
      {isClickedAddPaymentOption && <AddPaymentOptionModal onClickSave={onClickSavePaymentOption} onClickExit={() => setIsClickedAddPaymentOption(false)} />}
      {
        (isClicked && !isUsePaymentSystem) &&
        <WaitingPagePaymentModal
          isUsePaymentSystem={isUsePaymentSystem}
          name={productName}
          coach={productCoach}
          validity={productValidity}
          cash={cash}
          card={card}
          discount={discount}
          notReceived={notReceived}
          point={point}
          merchantUid={merchantUid}
          totalRegistData={totalRegistData}
          onRegist={cancelFunction}
          cancel={onCompletePaymentForLinkpay}
          setIsLoading={setIsLoading}
          getApprovalDate={getApprovalDate}
          onClickOnSitePayment={onClickOnSitePayment} />
      }
      {
        (isClicked && isUsePaymentSystem) &&
        <LinkoPayPaymentModal
          onClickOnSitePayment={onClickOnSitePayment}
          onClickLinkoPay={onClickPaymentOnPayple}
          onClickExit={() => setIsClicked(false)} />
      }
      {/* {
        (isUsePaymentSystem && userData.isUseLinkPay && isLinkPay) ?
          <LinkPayMemberShipInfoView
            ref={InfoViewRef} 
            data={data} 
            startDate={startDate}
            setStartDate={setStartDate}
            endDate={endDate}
            setEndDate={setEndDate}
            userData={userData}
            totalPoint={totalPoint}
            registerClick={onClickRegistrationButton}   
            closeFn={closeFn}/>
          :
          <OnSitePaymentMemberShipInfoView 
            ref={InfoViewRef} 
            data={data} 
            startDate={startDate}
            setStartDate={setStartDate}
            endDate={endDate}
            setEndDate={setEndDate}
            userData={userData}
            totalPoint={totalPoint}
            registerClick={onClickRegistrationButton}   
            closeFn={closeFn}/>
      } */}
      <ModalView>
        {
          (isUsePaymentSystem && userData.isUseLinkPay && isLinkPay) &&
          <LinkPayBoxWrapper>
            <LinkPayBox>
              <Text fontFmaily='NotoSansKR-Bold' fontSize={16} color='#FFFFFF' cursor='default'>링크페이</Text>
            </LinkPayBox>
          </LinkPayBoxWrapper>
        }
        <MembershipBoxInnerWrapper isLinkPay={(isUsePaymentSystem && userData.isUseLinkPay && isLinkPay)}>
          {
            isEdit ?
              <Text fontFamily='NotoSansKR-Bold' fontSize={14} color='#232323' cursor='default'>회원권 정보 수정</Text>
              :
              <Text fontFamily='NotoSansKR-Bold' fontSize={14} color='#232323' cursor='default'>회원권 추가</Text>
          }
          <DivisionLine margin={10} />
          <TitleWrapper>
            <Text fontFmaily='NotoSansKR-Regular' fontSize={12} color='#000000' cursor='default'>이전 등록 회원권 정보</Text>
          </TitleWrapper>
          <InfoBox>
            <RowWrapper onClick={onClickPrevSales} onMouseOver={onMouseOverPrevSales} onMouseLeave={onMouseLeavePrevSales}>
              <PrevSalesInfoBoxWrapper width={138} marginRight={5}>
                <Text fontFamily='NotoSansKR-Medium' fontSize={12} color='#000000' cursor='default'>회원권</Text>
                <PrevSalesTextWrapper>
                  <Text fontFamily='NotoSansKR-Regular' fontSize={12} color={prevSalesColor} cursor='pointer'>{onCalcPrevSalesInfo('MemberShipName')}</Text>
                </PrevSalesTextWrapper>
              </PrevSalesInfoBoxWrapper>
              <PrevSalesInfoBoxWrapper width={105} marginRight={5}>
                <Text fontFamily='NotoSansKR-Medium' fontSize={12} color='#000000' cursor='default'>기간</Text>
                <PrevSalesTextWrapper>
                  <Text fontFamily='NotoSansKR-Regular' fontSize={12} color={prevSalesColor} cursor='pointer'>{onCalcPrevSalesInfo('Date')}</Text>
                </PrevSalesTextWrapper>
              </PrevSalesInfoBoxWrapper>
              <PrevSalesInfoBoxWrapper width={120} marginRight={5}>
                <Text fontFamily='NotoSansKR-Medium' fontSize={12} color='#000000' cursor='default'>결제금액</Text>
                <PrevSalesTextWrapper>
                  <Text fontFamily='NotoSansKR-Regular' fontSize={12} color={prevSalesColor} cursor='pointer'>{onCalcPrevSalesInfo('TotalPrice')}</Text>
                </PrevSalesTextWrapper>
              </PrevSalesInfoBoxWrapper>
              <PrevSalesInfoBoxWrapper width={65} marginRight={5}>
                <Text fontFamily='NotoSansKR-Medium' fontSize={12} color='#000000' cursor='default'>미수금</Text>
                <PrevSalesTextWrapper>
                  <Text fontFamily='NotoSansKR-Regular' fontSize={12} color={prevSalesColor} cursor='pointer'>{onCalcPrevSalesInfo('NotReceivedPrice')}</Text>
                </PrevSalesTextWrapper>
              </PrevSalesInfoBoxWrapper>
              <PrevSalesInfoBoxWrapper width={50} marginRight={5}>
                <Text fontFamily='NotoSansKR-Medium' fontSize={12} color='#000000' cursor='default'>남은 일수</Text>
                <PrevSalesTextWrapper>
                  <Text fontFamily='NotoSansKR-Regular' fontSize={12} color={prevSalesColor} cursor='pointer'>{onCalcPrevSalesInfo('Validity')}</Text>
                </PrevSalesTextWrapper>
              </PrevSalesInfoBoxWrapper>
              <PrevSalesInfoBoxWrapper width={50}>
                <Text fontFamily='NotoSansKR-Medium' fontSize={12} color='#000000' cursor='default'>수강 횟수</Text>
                <PrevSalesTextWrapper>
                  <Text fontFamily='NotoSansKR-Regular' fontSize={12} color={prevSalesColor} cursor='pointer'>{onCalcPrevSalesInfo('TotalMax')}</Text>
                </PrevSalesTextWrapper>
              </PrevSalesInfoBoxWrapper>
            </RowWrapper>
          </InfoBox>
          <LayerWrapper
            marginTop={0}
            gap={20}
            style={{ zIndex: selectedPaymentOptions.length + 3 }}>
            <InputWrapper>
              <Text fontFamily='NotoSansKR-Regular' fontSize={12} color='#000000' cursor='default'>카테고리</Text>
              <OptionSelectBox
                value={selectedCategory}
                setValue={setSelectedCategory}
                options={categories}
                disabled={categories.length === 0}
                width={266} />
            </InputWrapper>
            <InputWrapper>
              <Text fontFamily='NotoSansKR-Regular' fontSize={12} color='#000000' cursor='default'>회원권</Text>
              <OptionSelectBox
                value={selectedMembership}
                setValue={setSelectedMembership}
                options={categorizedMemberships}
                disabled={categorizedMemberships.length === 0}
                width={266} />
            </InputWrapper>
          </LayerWrapper>
          <LayerWrapper
            marginTop={10}
            gap={20}
            style={{ zIndex: selectedPaymentOptions.length + 2 }}>
            <InputWrapper>
              <Text fontFamily='NotoSansKR-Regular' fontSize={12} color='#000000' cursor='default'>시작일</Text>
              <CalenderInput
                value={startDate}
                setValue={setStartDate}
                disabled={false}
                placeholder='시작일'
                width={123} />
            </InputWrapper>
            <InputWrapper>
              <Text fontFamily='NotoSansKR-Regular' fontSize={12} color='#000000' cursor='default'>종료일</Text>
              <CalenderInput
                value={endDate}
                setValue={setEndDate}
                disabled={false}
                placeholder='종료일'
                width={123} />
            </InputWrapper>
            <InputWrapper>
              <Text fontFamily='NotoSansKR-Regular' fontSize={12} color='#000000' cursor='default'>최대 수강 횟수</Text>
              <UnitInputWrapper>
                <CustomInput
                  value={totalMax === -1 ? '제한 없음' : totalMax}
                  setValue={onChangeTotalMax}
                  placeholder='0'
                  disabled={totalMax === -1}
                  width={231} />
                <Text fontFamily='NotoSansKR-Regular' fontSize={12} color='#000000' cursor='default'>회</Text>
              </UnitInputWrapper>
            </InputWrapper>
          </LayerWrapper>
        </MembershipBoxInnerWrapper>
        <PaymentInfoWrapper marginTop={20}>
          <Text fontFamily='NotoSansKR-Medium' fontSize={14} color='#232323' cursor='default'>결제 정보</Text>
          <DivisionLine margin={10} />
          <LayerWrapper
            marginTop={0}
            gap={10}
            style={{ zIndex: selectedPaymentOptions.length + 1 }}>
            <InputWrapper>
              <Text fontFamily='NotoSansKR-Regular' fontSize={12} color='#000000' cursor='default'>결제일</Text>
              <CalenderInput
                value={approvalDate}
                setValue={setApprovalDate}
                disabled={false}
                placeholder='결제일'
                width={266} />
            </InputWrapper>
            <RowDivisionLine />
            <InputWrapper>
              <Text fontFamily='NotoSansKR-Regular' fontSize={12} color='#000000' cursor='default'>회원권 가격</Text>
              <UnitInputWrapper>
                <CustomInput
                  value={selectedMembership.id === 0 ? '0' : selectedMembership.price.toLocaleString('ko-KR')}
                  placeholder='0'
                  disabled={true}
                  textAlign='right'
                  width={231} />
                <Text fontFamily='NotoSansKR-Regular' fontSize={12} color='#000000' cursor='default'>원</Text>
              </UnitInputWrapper>
            </InputWrapper>
          </LayerWrapper>
          {
            selectedPaymentOptions.map((data, index) => (
              <LayerWrapper
                key={'SelectedPaymentOptions-' + index}
                marginTop={10}
                gap={10}
                style={{ zIndex: selectedPaymentOptions.length - index }}>
                <InputWrapper>
                  <PaymentOptionTitleWrapper>
                    <Text fontFamily='NotoSansKR-Regular' fontSize={12} color='#000000' cursor='default'>{'결제 수단 ' + (index === 0 ? '' : index + 1)}</Text>
                    {
                      index !== 0 &&
                      <DeleteButton onClick={() => onClickDeletePaymentOptions(index)}>
                        <DeleteIcon src={WhiteTrashIcon} />
                      </DeleteButton>
                    }
                  </PaymentOptionTitleWrapper>
                  <PaymentOptionSettingSelectBox
                    index={index}
                    value={data}
                    setValue={onChangeSelectedPaymentOptions}
                    options={paymentOptions}
                    disabled={paymentOptions.length === 0}
                    width={266}
                    onClickAdditionOption={onClickAdditionOption}
                    onClickDeleteOption={onClickDeleteOption} />
                </InputWrapper>
                <RowDivisionLine />
                <InputWrapper>
                  <PaymentOptionTitleWrapper>
                    <Text fontFamily='NotoSansKR-Regular' fontSize={12} color='#000000' cursor='default'>받은 가격</Text>
                    {(data.paymentOptionId === 0 || (data.paymentOptionId === undefined && data.id === 0)) && data.name === '포인트' && <Text fontFamily='NotoSansKR-Regular' fontSize={12} color='#6DD49E' cursor='default'>{totalPoint.toLocaleString('ko-KR') + 'P 사용가능'}</Text>}
                  </PaymentOptionTitleWrapper>
                  <UnitInputWrapper>
                    <PaymentOptionCustomInput
                      index={index}
                      value={(data.price ?? 0).toLocaleString('ko-KR')}
                      setValue={onChangePaymentOptionPrice}
                      placeholder='0'
                      disabled={false}
                      textAlign='right'
                      width={231} />
                    <Text fontFamily='NotoSansKR-Regular' fontSize={12} color='#000000' cursor='default'>원</Text>
                  </UnitInputWrapper>
                </InputWrapper>
              </LayerWrapper>
            ))
          }
        </PaymentInfoWrapper>
        <AddPaymentOptionButton onClick={onClickAddPaymentOptions}>+ 결제 수단 추가</AddPaymentOptionButton>
        <LayerWrapper marginTop={20} gap={10}>
          <InputWrapper>
            <Text fontFamily='NotoSansKR-Regular' fontSize={12} color='#000000' cursor='default'>할인 금액</Text>
            <UnitInputWrapper>
              <ColorCustomInput
                value={discount.toLocaleString('ko-KR')}
                setValue={onChangeDiscount}
                placeholder='0'
                disabled={false}
                textAlign='right'
                width={231}
                color='#6DD49E' />
              <Text fontFamily='NotoSansKR-Regular' fontSize={12} color='#6DD49E' cursor='default'>원</Text>
            </UnitInputWrapper>
          </InputWrapper>
          <RowDivisionLine />
          <InputWrapper>
            <Text fontFamily='NotoSansKR-Regular' fontSize={12} color='#000000' cursor='default'>미수금</Text>
            <UnitInputWrapper>
              <NotReceivedInputView width={231}>
                <Text fontFamily='NotoSansKR-Regular' fontSize={14} color='#D92828' cursor='default'>{notReceived.toLocaleString('ko-KR')}</Text>
              </NotReceivedInputView>
              <Text fontFamily='NotoSansKR-Regular' fontSize={12} color='#D92828' cursor='default'>원</Text>
            </UnitInputWrapper>
          </InputWrapper>
        </LayerWrapper>
        <ButtonWrapper>
          <ExitButton onClick={closeFn}>
            <Text fontFamily='NotoSansKR-Medium' fontSize={14} color='#000000' cursor='pointer'>취소</Text>
          </ExitButton>
          <SaveButton onClick={onClickRegistrationButton}>
            <Text fontFamily='NotoSansKR-Medium' fontSize={14} color='#FFFFFF' cursor='pointer'>저장하기</Text>
          </SaveButton>
        </ButtonWrapper>
      </ModalView>
    </TopLevelWrapper>
  )
}//

export default OnSitePaymentModal;

const startAnimation = keyframes`
	0% { opacity: 0; }
	50% { opacity: 0.5; }
	100% { opacity: 1; }
`;

const TopLevelWrapper = styled.div`
  position: fixed;
  display: flex;
  flex-direction: column;

  top: 0;
  right: 0;
  bottom: 0;
  left: 0;

  // justify-content: center;
  justify-content: flex-start;
  align-items: center;

  z-index: 1000;

  width: 100vw;
  height: 100vh;

  overflow: scroll;

  background-color: rgba(0, 0, 0, 0.2);
	
	animation-name: ${startAnimation};
	animation-duration: 0.5s;
	animation-timing-function: ease-out;

  &::-webkit-scrollbar {
    height: 2px;
    width: 1px;
  }

  &::-webkit-scrollbar-thumb {
		border: 2px solid transparent;
		background-color: #DADADA;
		border-radius: 200px;
	}

  &::-webkit-scrollbar-track {
		background-color: #F0F0F0;
		border-radius: 200px;
	}
`;

const ModalView = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  margin: 60px 0px;
  padding: 20px;

  width: 553px;

  border-radius: 10px;
  background-color: #FFFFFF;
`;

const LinkPayBoxWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-end;

  margin: -20px -40px 0px 0px;

  width: 100%;
`;

const LinkPayBox = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 102px;
  height: 27px;

  border-top-right-radius: 10px;
  border-bottom-left-radius: 10px;

  background-color: #6DD49E;
`;


const TitleWrapper = styled.div`
  display: flex;
  flex-direction: row;
  
  justify-content: space-between;
  align-items: center;

  width: 100%
`;

const InfoBox = styled.div`
  display: flex;
  flex-direction: column;

  // margin-top: 10px;

  width: 100%
`;

const RowWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: flex-start;

  margin-top: 12px;

  width: 100%;
  height: 60px;

  :hover {
    cursor: pointer;
  }
`;

const PrevSalesInfoBoxWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  margin-right: ${props => props.marginRight}px;

  width: ${props => props.width}px;
  height: 48px;

  overflow: hidden;
  gap: 8px;
`;

const PrevSalesTextWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  width: 100%;
  height: 15px;

  overflow: hidden; 
`;

const MembershipBoxInnerWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  margin-top: ${props => props.isLinkPay ? '-10px' : '0px'};

  width: 100%;
`;

const LayerWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;
  
  margin-top: ${props => props.marginTop}px;

  width: 100%;

  gap: ${props => props.gap}px;
`;

const InputWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  gap: 4px;
`;

const UnitInputWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  gap: 4px;
`;

const NotReceivedInputView = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-end;
  align-items: center;

	padding: 0 8px;

  width: ${props => props.width}px;
  height: 30px;

	border: 1px solid #D92828;
	border-radius: 5px;
  background-color: #FFFFFF;
`;

const PaymentInfoWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  margin-top: ${props => props.marginTop}px;

  width: 100%;
`;

const DivisionLine = styled.div`
  margin-top: ${props => props.margin}px;
  margin-bottom: ${props => props.margin}px;

  width: 100%;
  height: 1px;

  background-color: #B3B3B3;
`;

const RowDivisionLine = styled.div`
  width: 1px;
  height: 54px;

  background-color #B3B3B3;
`;

const AddPaymentOptionButton = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  margin-top: 20px;

  width: 100%;
  height: 40px;
  
  border-radius: 5px;
  background-color: #F2F2F2;

  font-family: NotoSansKR-Bold;
  font-size: 14px;

  color: #CBCBCB;

  :hover {
    cursor: pointer;
    color: #FFFFFF;
    background-color #6DD49E;
  }

  transition: all 0.3s ease-in-out;
`;

const DeleteButton = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 24px;
  height: 18px;

  border-radius: 2px;
  background-color: #EC9393;

  :hover {
    cursor: pointer;
    background-color: #D92828;
  }

  transition: all 0.3s ease-in-out;
`;

const DeleteIcon = styled.img`
  width: 14px;
  height: 14px;
`;

const PaymentOptionTitleWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: space-between;
  align-items: center;

  width: 100%;
`;

const ButtonWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-end;
  align-items: center;

  margin-top: 20px;

  width: 100%;

  gap: 10px;
`;

const ExitButton = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 66px;
  height: 40px;

  border-radius: 8px;
  background-color: #F2F2F2;

  :hover {
    cursor: pointer;
  }
`;

const SaveButton = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 92px;
  height: 40px;

  border-radius: 8px;
  background-color: #5BD98A;

  :hover {
    cursor: pointer;
  }
`;

const Text = styled.p`
  font-family: ${props => props.fontFamily};
  font-size: ${props => props.fontSize}px;

  margin: 0 0 0 0;

  color: ${props => props.color};

  :hover {
    cursor: ${props => props.cursor};
  }

  transition: all 0.3s ease-in-out;
`;